<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <iframe v-if="frameName" :name="frameName" :title="_('Storefront')" style="width: 100%; height: 100%; border: 0"></iframe>
    <!-- Opens the storefront through the staff login bridge (same as the product Preview button),
         so the storefront knows the staff user and shows its preview bar -->
    <form v-if="frameName" ref="previewForm" method="post" action="/api/auth/storefront-preview" :target="frameName" style="display: none">
      <input type="hidden" name="shopId" :value="shopId">
      <input type="hidden" name="redirect" :value="frontPagePath">
      <input type="hidden" name="embed" value="1">
    </form>
  </div>
</template>

<script>

import components from '~/lib/components'
import { mapGetters } from 'vuex'

// Each Storefront tab gets its own frame name for the form to target (set in the browser,
// before the frame exists: a frame renamed later keeps its first name in some browsers)
let frameCount = 0

export default {
  data () {
    return {
      frameName: ''
    }
  },
  mixins: [components],
  computed: {
    ...mapGetters(['shopId', 'version']),
    frontPagePath () {
      return this.version ? '/' + this.version : '/'
    },
    frameKey () {
      return this.shopId ? this.shopId + this.frontPagePath : ''
    }
  },
  watch: {
    frameKey () {
      this.open()
    }
  },
  mounted () {
    this.frameName = 'storefront-frame-' + (++frameCount)
    this.open()
  },
  methods: {
    open () {
      if (!this.frameKey || !this.frameName) {
        return
      }
      this.$nextTick(() => {
        if (this.$refs.previewForm) {
          this.$refs.previewForm.submit()
        }
      })
    }
  }
}

</script>
